import { render, staticRenderFns } from "./RiskAnalysisForm.vue?vue&type=template&id=366123e5"
import script from "./RiskAnalysisForm.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports